export default {
    methods: {
        handlerFilter() {
            console.info('ready to do the filter')
        },
        handlerCleanFilter() {
            console.info('ready to clean the filter')
        },
        formatCurrency(value) {
            const formatter = new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'EUR',
                maximumFractionDigits: 0,
            })
            return formatter.format(value)
        },
    },
}
